import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

export const BrandCard = ({ brand }) => (
  <motion.div
    variants={{ hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0, transition: { duration: 0.5 } } }}
  >
    <Link
      to={`/phones?brand=${brand.id}`}
      data-testid={`brand-card-${brand.id}`}
      className="group relative flex h-24 items-center justify-center rounded-2xl border border-border bg-card transition-colors hover:border-[hsl(var(--ink))]"
    >
      <span className="font-display text-xl font-semibold tracking-tight">{brand.name}</span>
      <ArrowUpRight className="absolute right-3 top-3 h-4 w-4 text-[hsl(var(--ink-soft))] opacity-0 transition-opacity group-hover:opacity-100" />
    </Link>
  </motion.div>
);
